import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import footerProd1 from '../Images/footer-grip-bond.png'
import footerProd2 from '../Images/footer-pro-bond.png'
import footerProd3 from '../Images/footer-ultra-bond.png'
import callIcon from '../Images/call-icon.png'
import mailIcon from '../Images/mail-icon.png'
import fbIcon from '../Images/facebook.png'
import linkedinIcon from '../Images/linkedin.png'
import whiteLogo from '../Images/white-logo.png'
import { ReactComponent as ChatGPTLogo } from "./chatgpt.svg";
import { ReactComponent as ClaudeLogo } from "./claude.svg";
import { ReactComponent as GeminiLogo } from "./gemini.svg";
import { ReactComponent as PerplexityLogo } from "./perplexity.svg";

const Footer = () => {

  // Container (stagger columns)
  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.2,
      },
    },
  };

  // Fade only (no movement)
  const fade = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const prompt="Act as a business strategy consultant. Analyze https://vigoflex.in/ to understand how VigoFlex operates as a tile adhesive and construction chemicals manufacturer. Summarize their value proposition, product portfolio (such as Grip Bond, Pro Bond, and Ultra Bond), polymer-enriched technology, target B2B and retail audiences, application areas, and the key reasons contractors, builders, and homeowners choose their bonding solutions. Highlight their manufacturing capabilities, quality standards, and digital tools like their project calculator."
  const openAI = (type) => {
  const encoded = encodeURIComponent(prompt);

  const urls = {
    chatgpt: `https://chatgpt.com/?q=${encoded}`,
    claude: `https://claude.ai/new?q=${encoded}`,
    gemini: `https://www.google.com/search?q=${encoded}&udm=50`,
    perplexity: `https://www.perplexity.ai/search?q=${encoded}`,
  };

  window.open(urls[type], "_blank");
};

  const footerLinks = [
  { name: "Home", path: "/" },
  { name: "About us", path: "/about-us" },
  { name: "Applications", path: "/applications" }, // or dropdown page if needed
  { name: "Calculator", path: "/calculator" },
  { name: "Contact us", path: "/contact-us" },
  { name: "Privacy Policy", path: "/privacy-policy" },
];

  return (
    <footer className="footer">

      <motion.div
        className="footer-container"
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >

        {/* Brand Column */}
        <motion.div className="footer-col footer-col-brand" variants={fade}>
        <img 
  src={whiteLogo} 
  alt="VigoFlex Logo" 
  className="footer-logo" 
/>
          <p className="section-text">
           VigoFlex offers high-performance tile adhesives engineered for strong, durable, and long-lasting bonding across a wide range of surfaces and applications.
          </p>

            <h5 className="footer-heading" style={{ marginTop: '30px' }}>
           Ask AI About Vigoflex
          </h5>

          <div className="social-links">
            <button className="ai-btn" onClick={() => openAI("chatgpt")}>
    <ChatGPTLogo className="ai-logo" />
  </button>

  <button className="ai-btn" onClick={() => openAI("claude")}>
    <ClaudeLogo className="ai-logo" />
  </button>

  <button className="ai-btn" onClick={() => openAI("gemini")}>
    <GeminiLogo className="ai-logo" />
  </button>

  <button className="ai-btn" onClick={() => openAI("perplexity")}>
    <PerplexityLogo className="ai-logo" />
  </button>
 
          </div>
        </motion.div>

        {/* Links Column */}
        <motion.div className="footer-col footer-col-links" variants={fade}>
          <h5 className="footer-heading">Quick Links</h5>
          <ul className="footer-list">
  {footerLinks.map((item, i) => (
    <li key={i}>
      <motion.div whileHover={{ opacity: 0.7 }}>
        <Link to={item.path} className="footer-link-item">
          <span>&gt;</span> {item.name}
        </Link>
      </motion.div>
    </li>
  ))}
</ul>
        </motion.div>

        {/* Products Column */}
        <motion.div className="footer-col footer-col-products" variants={fade}>
          <h5 className="footer-heading">Products</h5>

          {[{
  img: footerProd1,
  title: "Grip Bond",
  desc: "Interior floors, small-medium tiles",
  path: "grip-bond"
},{
  img: footerProd2,
  title: "Pro Bond",
  desc: "Interior walls & floors, Large-medium tiles",
  path: "pro-bond"
},{
  img: footerProd3,
  title: "Ultra Bond",
  desc: "Exterior areas, Large tiles, Heavy-duty use",
  path: "ultra-bond"
}].map((item, i) => (
  <Link to={`/products/${item.path}`} key={i}>
    <motion.div
      className="footer-product-item"
      variants={fade}
      whileHover={{ opacity: 0.85 }}
    >
      <img
        src={item.img}
        alt={`${item.title} | VigoFlex`}
        className="footer-prod-img"
      />

      <div className="footer-prod-info">
        <h6>{item.title}</h6>
        <p>{item.desc}</p>
      </div>
    </motion.div>
  </Link>
))}
        </motion.div>

        {/* Contact Column */}
        <motion.div className="footer-col footer-col-contact" variants={fade}>
          <h5 className="footer-heading">Contact Us</h5>

          <div className="contact-info">

  {/* CALL */}
  <a href="tel:+917016591400" className="contact-item">
    <img src={callIcon} alt="Call Icon | VigoFlex" className="contact-icon-img" />
    +91 70165 91400
  </a>

  {/* EMAIL */}
  <a href="mailto:info@vigoflex.in" className="contact-item">
    <img src={mailIcon} alt="Email Icon | VigoFlex" className="contact-icon-img" />
   info@vigoflex.in
  </a>

</div>

          <h5 className="footer-heading" style={{ marginTop: '30px' }}>
            Follow Us
          </h5>

          <div className="social-links">
            <motion.a
              href="https://www.facebook.com/people/VigoFlex/61589199441217/"
              target="_blank"
              className="social-icon"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <img src={fbIcon} alt="Facebook Icon | VigoFlex" className="social-img" />
            </motion.a>

            <motion.a
              href="https://www.linkedin.com/company/vigoflex/"
              target="_blank"
              className="social-icon"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <img src={linkedinIcon} alt="LinkedIn Icon | VigoFlex" className="social-img" />
            </motion.a>
          </div>
        </motion.div>

      </motion.div>

      {/* Bottom */}
      <motion.div
        className="footer-bottom"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <div className="footer-bottom-container">
        <p>
  © 2026 VigoFlex. All Rights Reserved.</p><p> This site is protected by
  Google reCAPTCHA and the Google{" "}
  
  <a
    href="https://policies.google.com/privacy"
    target="_blank"
    rel="noopener noreferrer"
  >
    Privacy Policy
  </a>{" "}
  
  and{" "}
  
  <a
    href="https://policies.google.com/terms"
    target="_blank"
    rel="noopener noreferrer"
  >
    Terms of Service
  </a>{" "}
  
  apply.
</p>
</div>
      </motion.div>

    </footer>
  );
};

export default Footer;